interface PriceRange {
  min?: number | null;
  max?: number | null;
}

interface NormalizedPriceRange {
  type: string;
  min: number | null;
  max: number | null;
  isRange: boolean;
  isBaseRate: boolean;
  isHourlyRate: boolean;
  isTotal: boolean;
}

export const normalizePriceRange = (
  priceRange: PriceRange | Record<string, unknown>,
  bookingRate: number | null,
  bookingTotal: number | null,
): NormalizedPriceRange => {
  const rangeMin = priceRange?.min || null;
  const rangeMax = priceRange?.max || null;

  const hasRange = !!rangeMin && !!rangeMax;

  const isRange = !bookingRate && hasRange;
  const isTotal = !!bookingTotal;
  const isHourlyRate = !!bookingRate && !isTotal && !isRange;
  const isBaseRate = !bookingRate && !isTotal && !isRange;

  const type = isRange
    ? "range"
    : isTotal
      ? "total"
      : isHourlyRate
        ? "hourly"
        : "base rate";

  return {
    type,
    min: rangeMin as number | null,
    max: rangeMax as number | null,
    isRange,
    isBaseRate,
    isHourlyRate,
    isTotal,
  };
};
